export const tokens = {
  vDarkMagenta: 'hsl(300, 43%, 22%)',
  softPink: 'hsl(333, 80%, 67%)',
  darkGrayishMagenta: 'hsl(303, 10%, 53%)',
  lightGrayishMagenta: 'hsl(300, 24%, 96%)',
  white: 'hsl(0, 0%, 100%)'
};
